// extracted by mini-css-extract-plugin
export var hasPanned = "PanableImage-module--hasPanned--gRJqq";
export var image = "PanableImage-module--image--yJ874";
export var isTouch = "PanableImage-module--isTouch--4pljz";
export var panHint = "PanableImage-module--panHint--ZGqCE";
export var panable = "PanableImage-module--panable--zOSkT";
export var root = "PanableImage-module--root--LsFT-";